/**
 * Safe display identity for auth chrome (topbar/sidebar).
 * Never invents demo/mock names when the session is missing.
 */

export type UserDisplayIdentity = {
  fullName: string;
  initials: string;
  email: string | null;
};

type AuthUserLike = {
  email?: string | null;
  user_metadata?: {
    full_name?: string | null;
  } | null;
} | null | undefined;

export function resolveUserDisplayIdentity(user: AuthUserLike): UserDisplayIdentity | null {
  if (!user) return null;

  const email = typeof user.email === 'string' && user.email.trim() ? user.email.trim() : null;
  const metaName =
    typeof user.user_metadata?.full_name === 'string' && user.user_metadata.full_name.trim()
      ? user.user_metadata.full_name.trim()
      : null;

  const fullName = metaName || (email ? email.split('@')[0] : null);
  if (!fullName) return null;

  const initials = metaName
    ? metaName
        .split(/\s+/)
        .filter(Boolean)
        .map((part) => part[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    : email
      ? email.slice(0, 2).toUpperCase()
      : fullName.slice(0, 2).toUpperCase();

  return {
    fullName,
    initials: initials || fullName.slice(0, 1).toUpperCase(),
    email,
  };
}
